
import _ from 'lodash';
import { PEOPLE_MODULE_CONTACT } from 'shared/constants';

export const getContactHrefByType = (type, value) => {
  switch (type) {
    case PEOPLE_MODULE_CONTACT.MAIL:
      return `mailto:${value}`;
    case PEOPLE_MODULE_CONTACT.PHONE:
      return `tel:${value}`;
    default:
      return value;
  }
};

export const getTextModuleDefaultLang = content =>
  Object.keys(content.title || {})[0] || Object.keys(content.text || {})[0];

export const getPeopleModuleDefaultLang = content =>
  Object.keys(content.title || {})[0]
  || Object.keys(content.description || {})[0]
  || Object.keys((content.persons.find(person => !_.isEmpty(person.headline)) || {}).headline || {})[0]
  || Object.keys((content.persons.find(person => !_.isEmpty(person.description)) || {}).description || {})[0];

export const getGalleryModuleDefaultLang = content =>
  Object.keys(content.title || {})[0]
    || Object.keys(content.description || {})[0]
    || Object.keys((content.photos.find(photo => !_.isEmpty(photo.description)) || {}).description || {})[0];

export default {
  getContactHrefByType,
  getTextModuleDefaultLang,
  getPeopleModuleDefaultLang,
  getGalleryModuleDefaultLang,
};
